import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { fonts } from "theme/fonts";
import { firebase, EventContext, UserContext, AnalyticsContext } from "context";
import { useDocumentData } from "react-firebase-hooks/firestore";

export const PoweredBy = ({ zipCode, postCampaign }) => {
  const [dealer, setDealer] = useState();
  const [fdaf, loading, error] = useDocumentData(
    firebase.firestore().doc(`geo/ford/fdaf/${zipCode}`)
  );

  let string = fdaf?.fdaf;
  useEffect(() => {
    if (string) {
      let newStr = string
        .replace("Dealers", "")
        .replace("Greater Texas Ford", "Tus Concesionarios Ford de Tejas")
        .replace("North Texas Ford", "Tus Concesionarios Ford de Tejas")
        .replace("Houston Ford", "Tus Concesionarios Ford")
        .replace("Oklahoma Ford", "Tus Concesionarios Ford")
        .replace("St Louis Ford", "Tus Concesionarios Ford")
        .replace("Midwest Ford", "Tus Concesionarios Ford")
        .replace("Southern Quality Ford", "Tus Concesionarios Ford")
        .replace("Midsouth Ford", "Tus Concesionarios Ford")
        .replace("Desert Ford", "Tus Concesionarios Desert Ford")
        .replace("Cincinnatti North Ford", "Tus Concesionarios Ford")
        .replace("Cincinnati North Ford", "Tus Concesionarios Ford")
        .replace("Northern California Ford", "Tus Concesionarios Ford");
      setDealer(newStr);
    }
  }, [string]);

  if (loading) return null;

  return (
    <SubBody>
      Impulsado por {dealer ? dealer : "Tus Concesionarios Ford"}
    </SubBody>
  );
};

const SubBody = styled.p`
  font-size: 13px;
`;
